import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../config/firebase';

export const useTasksData = () => {
  const [tasks, setTasks] = useState({});

  useEffect(() => {
    const tasksRef = ref(database, 'tasks');
    const unsubscribeTasks = onValue(tasksRef, (snapshot) => {
      const data = snapshot.val();
      setTasks(data || {});
    });

    return () => {
      unsubscribeTasks();
    };
  }, []);

  return { tasks, setTasks };
}; 